import React, { Component } from "react";
import moment from 'moment';
import LiveClassDetails from '../home/LiveClassDetails';
import CancelBooking from '../home/CancelBooking';
import { bookmarkClass } from  '../../utils/bookmarkClass';
import { showMainErrorPop } from '../../actions/popups';
import { connect } from "react-redux";
import classnames from "classnames";
import { openLiveClass } from  '../../utils/openLiveClass';
import ParticipantSignedUp from '../home/participantSignedUp';
import LoginAnotherUserPopup from '../home/LoginAnotherUserPopup';
import { joinSessionValidate } from '../../utils/joinSessionValidate';
import customProtocolCheck from "custom-protocol-check";
import { osName as osname, isTablet as tablet, isMobile as mobile, isAndroid as android, isIOS as ios, deviceType as deviceType, browserName as browserName } from "react-device-detect";

import axiosVirdioT from '../../utils/axios';
var axiosVirdio;

class MarketplaceLive extends Component {
  
  constructor(props) {
	super(props);
	
	this.state={
		chosenInterest: [],
		classInterests: [],
		allClasses: [],
		classesDates: [],
		classesByInterest: [],
		classInfo: {},
		classBoking: false,
		sessionToCancel: 0,
		pageCount: 0,
		liveClassesLength: 0,
		liveClassesTotalLength: 0,
		currentUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		defaultJoinTime: localStorage.getItem('userData') ? parseInt(JSON.parse(localStorage.getItem('userData')).default.defaultSessionDuration) : 15,
		isLoadedClasses: false,
		instructorsFilter: [],
		pastOnDemandClassesTotalLength: 0,
		pastTotalLength: 0,
		arrayTemp: [],
		arrayTempLength: 0,
		pastOnDemandClasses: [],
		pastClasses: [],
		chosenInstructorsFilter: [],
		showAllActive: false,
		loggedUserData: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : {},
		showPopupLaunchApp: false,
		urlPath: '',
		urlElectron: '',
		deepLinkButton: '',
		sessionName: '',
		scheduleDate: '',
		isHost: false,
		channelName: '',
		paramsSessionId: 0,
		loggedNative: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).loggedNative : 0,
		loginAsAnotherUser: false,
		srchutm: ''
    }
	
	this.bookmarkClass = bookmarkClass.bind(this);
	this.openLiveClass = openLiveClass.bind(this);
	this.refDetails = React.createRef();
	this.joinSessionValidate = joinSessionValidate.bind(this);
	window['loginAsOtherUser'] = this.loginAsOtherUser;
}
 
componentDidMount(){
	
	if ( window.location.search && window.location.search.length > 2 && window.location.search.indexOf('utm') > 0 )
		{
			localStorage.setItem('utmsave', window.location.search);
		}
	
	if ( localStorage.getItem('utmsave') )
		{
			this.setState({srchutm: localStorage.getItem('utmsave')});
		}
	
	var appLink = window.location;
	var sessionId = '';		
		
	if ( appLink.hash.indexOf('#') > -1 )
		{
			var splitString = appLink.hash.split('#');
			if ( splitString.length > 1)
				{
					sessionId = splitString[1];
				}
		}
	
	if ( sessionId > 0 )
		{
			this.setState({paramsSessionId: sessionId});
		}
	
	axiosVirdio = new axiosVirdioT(this.props);
	if ( this.props.parentComponent && this.props.parentComponent == 'pastClasses' )
		{
			this.getPastClasses();
			this.getPastHosts();
		}
	else
		{
			if ( this.state.currentUserData.showLiveAndOnDemand )
				{
					this.setShowAll();
				}
		}
		
	if (this.props.openWithoutToken)
		{
			this.setState({showAllActive: true});
		}
}

fullLoad = (mod, showPopup) => {
	if ( localStorage.getItem('userData') )
		{
			let token1 = JSON.parse(localStorage.getItem('userData')).token;
			let loginId1 = JSON.parse(localStorage.getItem('userData')).id;
			
			var isHost = false;
			if ( mod.hostId === loginId1 ) { isHost = true; }
			
			var checkSessionValidate = this.joinSessionValidate(isHost, loginId1, token1, null);
			this.setState({ 
					urlPath: checkSessionValidate.urlPathVar,
					urlElectron: checkSessionValidate.urlElectronVar,
					deepLinkButton: checkSessionValidate.deepLinkButton,
					sessionName: mod.sessionName,
					scheduleDate: mod.scheduleDate,
					isHost: isHost,
					channelName: mod.channelName
			});
			
			if ( showPopup )
				{
					this.setState({showPopupLaunchApp: true});
				}
		}
}

getLiveClasses=(isNewInterest?, hideLoader?)=>{
	if ( !hideLoader ) { this.props.updateStateFromChild({showLoader: true}); }
	var postData = {'pageCount': this.state.pageCount, 'chosenInterest':this.state.chosenInterest};
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			postData['onlyBookmark'] = 1;
		}
	if ( this.state.showAllActive )
		{
			postData['showAll'] = true;
		}		
		
	let token = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).token : '';
	
	let linkVariable = 'getLiveClasses';
	
	if (this.props.openWithoutToken)
		{
			linkVariable = 'getLiveClassesGlobal';
			if (this.state.showAllActive)
				{
					postData['showAll'] = true;
				}
		}
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/'+linkVariable, postData).then(res => {
		
		this.props.updateStateFromChild({showLoader: false});
		var mainResponse = res.data.responseData;
		
		let tempAllClasses = this.state.allClasses;
		if ( isNewInterest )
			{
				tempAllClasses = [];
			}
			
		let finalAllClasses = tempAllClasses.concat(mainResponse.liveClasses);
		if ( finalAllClasses.length > 0 )
			{
				for ( var i = 0; i < finalAllClasses.length; i++ )
					{
						var timeRemaining = Math.floor((new Date(finalAllClasses[i]['scheduleDate']).getTime() - new Date().getTime())/1000);
						finalAllClasses[i]['timeUntil'] = timeRemaining;
					}
			}
		
		let tempClassInterests = mainResponse.classInterests;	
		
		this.setState({
			classInterests: tempClassInterests, 
			allClasses: finalAllClasses,
			liveClassesLength: finalAllClasses.length,
			liveClassesTotalLength: mainResponse.liveClassesTotalLength,
			isLoadedClasses: true,
			chosenInterest: mainResponse.chosenInterestFilter
		}, () => {
				this.setClassesByInterest(this.state.chosenInterest);
				if ( this.state.paramsSessionId > 0 && !this.state.showPopupLaunchApp )
					{
						let foundedSession = false;
						let sessionData = {};
						for ( var i = 0; i < this.state.allClasses.length; i++ )
							{
								if ( this.state.allClasses[i]['sessionId'] == this.state.paramsSessionId )
									{
										foundedSession = true;
										sessionData = this.state.allClasses[i];
									}
							}
						if ( foundedSession )
							{
								this.fullLoad(sessionData, true);
							}
					}
			});
	}).catch(err =>{ 
		this.props.updateStateFromChild({showLoader: false});
	});   
}

getPastClasses=(isNewInterest?, hideLoader?)=>{
	if ( !hideLoader ) { this.props.updateStateFromChild({showLoader: true}); }
	var postData = {
		'pageCount': this.state.pageCount, 
		'chosenInterest':this.state.chosenInterest,
		'chosenInstructorsFilter': this.state.chosenInstructorsFilter
	};
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			postData['onlyBookmark'] = 1;
		}
	
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getPastClasses', postData).then(res => {
		
		this.props.updateStateFromChild({showLoader: false});
		var mainResponse = res.data.responseData;
		
		let tempAllClasses = this.state.arrayTemp;
	
		let pastClasses = this.state.pastClasses;
		let pastOnDemandClasses = this.state.pastOnDemandClasses;
		if ( isNewInterest )
			{
				tempAllClasses = [];
				pastClasses = [];
				pastOnDemandClasses = [];
			}
			
		let finalAllClasses = tempAllClasses.concat(mainResponse.pastClasses);
		finalAllClasses = finalAllClasses.concat(mainResponse.pastOnDemandClasses);
		
		let finalPastClasses = pastClasses.concat(mainResponse.pastClasses);
		let finalPastOnDemandClasses = pastOnDemandClasses.concat(mainResponse.pastOnDemandClasses);
		
		let tempClassInterests = mainResponse.classInterests;
		
		finalAllClasses.sort(function(a, b){
				if(a.scheduleDate > b.scheduleDate) { return -1; }
				if(a.scheduleDate < b.scheduleDate) { return 1; }
				return 0;
			});
			
		let arrayTemp = finalAllClasses;
		let arrayTempLength = finalAllClasses.length;
		
		let sliceTemp = [];
		let sliceTempLength = 0;
		if ( finalAllClasses.length > 50 )
			{
				sliceTemp = finalAllClasses.slice(0, (this.state.pageCount+1)*50);
				sliceTempLength = sliceTemp.length;
			}
		else
			{
				sliceTemp = finalAllClasses;
				sliceTempLength = sliceTemp.length;
			}
			
		this.setState({
			classInterests: tempClassInterests, 
			allClasses: sliceTemp,
			liveClassesLength: sliceTempLength,
			liveClassesTotalLength: mainResponse.liveClassesTotalLength,
			isLoadedClasses: true,
			chosenInterest: mainResponse.interestFilterArray,
			pastOnDemandClassesTotalLength: mainResponse.pastOnDemandClassesTotalLength,
			pastTotalLength: mainResponse.liveClassesTotalLength+mainResponse.pastOnDemandClassesTotalLength,
			arrayTemp: arrayTemp,
			arrayTempLength: arrayTempLength,
			pastOnDemandClasses: finalPastOnDemandClasses,
			pastClasses: finalPastClasses
		}, () => {this.setClassesByInterest(this.state.chosenInterest)});
	}).catch(err =>{ this.props.updateStateFromChild({showLoader: false}); });   
}

changeInterest=(interestId)=>{
	var interestIds = this.state.chosenInterest;
	if ( interestIds.indexOf(interestId) > -1 && this.state.showAllActive == false ) 
		{ 
			return false; 
		}
	interestIds = [];
	interestIds.push(interestId);
	this.setState({
		chosenInterest: interestIds,
		pageCount: 0,
		showAllActive: false,
	}, ()=> { 
		this.getLiveClasses(true);
	});
}

setClassesByInterest=(interest)=>{
	var currentDate = new Date();
	var tomorrowDate = new Date().setDate(new Date().getDate() + 1);
	var yesterday = new Date().setDate(new Date().getDate() - 1);
	
	var classDates = [];
	var allClasses = this.state.allClasses;
	var liveClassesArray = [];
	
	if ( this.props.parentComponent && this.props.parentComponent == 'pastClasses' )
		{
			for ( var i = 0; i < allClasses.length; i++ )
				{
					var item = allClasses[i];
					
					var date = moment(item.scheduleDate).format('dddd, DD MMMM');
					
					if ( moment(currentDate).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
						{
							date = 'Today, ' + moment(item.scheduleDate).format('DD MMM');
						}
						
					if ( moment(yesterday).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
						{
							date = 'Yesterday, ' + moment(item.scheduleDate).format('DD MMM');
						}
						
					if ( classDates.indexOf(date) == -1 ) { classDates.push(date); }
				}

			for ( var y = 0; y < classDates.length; y++ )
				{
					for ( var z = 0; z < allClasses.length; z++ )
						{
							var itemClass = allClasses[z];
							
							var dateSession = moment(itemClass.scheduleDate).format('dddd, DD MMMM');
							
							if ( moment(currentDate).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Today, ' + moment(itemClass.scheduleDate).format('DD MMM');
								}
								
							if ( moment(yesterday).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Yesterday, ' + moment(itemClass.scheduleDate).format('DD MMM');
								}
								
								
							if ( dateSession == classDates[y] )
								{
									if ( !liveClassesArray[dateSession] ) { liveClassesArray[dateSession] = []; }
									
									liveClassesArray[dateSession].push(itemClass);
								}
						}
				}
		}
	else
		{
			for ( var i = 0; i < allClasses.length; i++ )
				{
					var item = allClasses[i];
					
					var date = moment(item.scheduleDate).format('dddd, DD MMMM');
					
					if ( moment(currentDate).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
						{
							date = 'Today, ' + moment(item.scheduleDate).format('DD MMM');
						}
						
					if ( moment(tomorrowDate).format('dddd, DD MMMM') == moment(item.scheduleDate).format('dddd, DD MMMM') )
						{
							date = 'Tomorrow, ' + moment(item.scheduleDate).format('DD MMM');
						}
						
					if ( classDates.indexOf(date) == -1 ) { classDates.push(date); }
				}

			for ( var y = 0; y < classDates.length; y++ )
				{
					for ( var z = 0; z < allClasses.length; z++ )
						{
							var itemClass = allClasses[z];
							
							var dateSession = moment(itemClass.scheduleDate).format('dddd, DD MMMM');
							
							if ( moment(currentDate).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Today, ' + moment(itemClass.scheduleDate).format('DD MMM');
								}
								
							if ( moment(tomorrowDate).format('dddd, DD MMMM') == moment(itemClass.scheduleDate).format('dddd, DD MMMM') )
								{
									dateSession = 'Tomorrow, ' + moment(itemClass.scheduleDate).format('DD MMM');
								}
								
								
							if ( dateSession == classDates[y] )
								{
									if ( !liveClassesArray[dateSession] ) { liveClassesArray[dateSession] = []; }
									
									liveClassesArray[dateSession].push(itemClass);
								}
						}
				}
		}
	this.setState({classesDates: classDates, classesByInterest: liveClassesArray}, () => {if ( !this.props.parentComponent || ( this.props.parentComponent && this.props.parentComponent != 'pastClasses') ) {this.countdownTimer()}});	
}

openClassDetails=(id)=>{
	if ( this.props.openWithoutToken && this.props.openWithoutToken == 'marketplaceglobal')
		{
			return false;
		}
	var postData = {classId: id};
	let token = JSON.parse(localStorage.getItem('userData')).token;
    axiosVirdio.auth(token);	 
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getClassDetails', postData).then(res => {
		
		var timeRemaining = Math.floor((new Date(res.data.responseData.scheduleDate).getTime() - new Date().getTime())/1000);
		res.data.responseData['timeUntil'] = timeRemaining;
		
		this.setState({
			classInfo: res.data.responseData
		}, () => this.props.updateStateFromChild({isOpenDetailedClass: true, openedLiveId: id}));
		
		this.refDetails.current.updateClassDetails(res.data.responseData);
	}).catch(err =>{ });   
}

openCancel=(id)=>{
	this.setState({
		classBoking: true, 
		sessionToCancel: id
	});
	
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			this.props.updateStateFromChild({isOpenCancel: true});
		}
}

updateStateFromChild=(state)=>{
	this.setState(state);
	
	if ( this.props.parentComponent == 'bookmarkClasses' && state['sessionToCancel'] !== undefined && state['sessionToCancel'] == 0 )
		{
			this.props.updateStateFromChild({isOpenCancel: false});
		}
}

loadMoreLiveSessions = ()=>{
	let tempPageCount = this.state.pageCount + 1;
	this.setState({pageCount: tempPageCount
	}, ()=>{this.getLiveClasses();});
}

bookSession = (id)=>{
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	var postData = {
		sessionId: id
	};
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axiosVirdio.auth(token);	 
	this.props.updateStateFromChild({showLoader: true});
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/bookSessionMarketplace', postData).then(res => {
		var allClasses = this.state.classesByInterest;
		this.state.classesDates.map((date, index) =>
			{
				this.state.classesByInterest[date].map((item, i) =>
					{
						if ( allClasses[date][i]['sessionId'] == id )
							{
								allClasses[date][i]['bookingStatus'] = 0;
							}
					});
			});
		
		this.setState({classesByInterest: allClasses});
		this.props.updateStateFromChild({showLoader: false});
	}).catch(err =>{
		let msg = err.response.data.errorData;
		if ( err.response.data.errorData.message && err.response.data.errorData.message != '' )
			{
				msg = err.response.data.errorData.message;
			}
		this.props.showMainErrorPop(msg);
		this.props.updateStateFromChild({showLoader: false});
	});
}

cancelSessionStatus = ()=>{
	var allClasses = this.state.classesByInterest;
	this.state.classesDates.map((date, index) =>
		{
			this.state.classesByInterest[date].map((item, i) =>
				{
					if ( allClasses[date][i]['sessionId'] == this.state.sessionToCancel )
						{
							allClasses[date][i]['bookingStatus'] = 4;
						}							
				});
		});
	
	this.setState({
			classesByInterest: allClasses,
			classBoking: false
		});
	
	if ( this.props.parentComponent == 'bookmarkClasses' )
		{
			this.props.updateStateFromChild({isOpenCancel: false});
		}
}

bookMarkClass=(e, item)=>{
	e.preventDefault();
	e.stopPropagation();
	
	if ( this.props.parentComponent && this.props.parentComponent == 'pastClasses' )
		{
			return false;
		}
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	var mainthis = this;
	var statusClass = 1;
	if ( item.isBookmarked == 1 ) { statusClass = 0; }
	this.props.updateStateFromChild({showLoader: true});
	this.bookmarkClass(item.sessionId, 1, statusClass).then(function(res){
		mainthis.getLiveClasses(true);
	}, function (err) { 
		mainthis.props.updateStateFromChild({showLoader: false});
		if ( err.response && err.response.data && err.response.data.errorData ) 
			{
				mainthis.props.showMainErrorPop(err.response.data.errorData); 
			}
	});
}

closeDetails=(id)=>{
	var allClasses = this.state.classesByInterest;
	this.state.classesDates.map((date, index) =>
		{
			this.state.classesByInterest[date].map((item, i) =>
				{
					if ( allClasses[date][i]['sessionId'] == id )
						{
							allClasses[date].splice(i,1);
						}							
				});
		});
	this.setState({
			classesByInterest: allClasses
		});
	this.props.closeDetails();
}

updateParent=(id, mod)=>{
	var allClasses = this.state.classesByInterest;
	this.state.classesDates.map((date, index) =>
		{
			this.state.classesByInterest[date].map((item, i) =>
				{
					if ( allClasses[date][i]['sessionId'] == id )
						{
							allClasses[date][i]['bookingStatus'] = mod;
						}							
				});
		});
	this.setState({
			classesByInterest: allClasses
		});
}

countdownTimer() {
	let mainthis = this;
    var x = setInterval(function() {
			
			var allClasses = mainthis.state.classesByInterest;
			mainthis.state.classesDates.map((date, index) =>
				{
					mainthis.state.classesByInterest[date].map((item, i) =>
						{
							var timeRemaining = Math.floor((new Date(item.scheduleDate).getTime() - new Date().getTime())/1000);
							allClasses[date][i]['timeUntil'] = timeRemaining;					
						});
				});
			
			mainthis.setState({
					classesByInterest: allClasses
				});
	}, 1000); 
  }
  
openClass=(id)=>{
	
	if ( this.props && this.props.state && this.props.state.failedPaymentStatus )
		{
			return false;
		}
	
	this.props.updateStateFromChild({showLoader: true});
	localStorage.removeItem('groupClass');
	this.openLiveClass(id);
}

getPastHosts=()=>{
	let token = JSON.parse(localStorage.getItem('userData')).token;
	axiosVirdio.auth(token); 
	axiosVirdio.post(process.env.REACT_APP_API_URL +'/api/v1/session/getPastClassesHosts').then(res => {
		this.setState({instructorsFilter: res.data.responseData});
	}).catch(err =>{ });
}

changePastInterest=(interestId)=>{
	var interestIds = this.state.chosenInterest;
	let newInterestArray = [];
	if ( interestIds.indexOf(interestId) == -1 ) 
		{
			newInterestArray.push(interestId);
		}
	else 
		{
			return false;
		}
	this.setState({
		chosenInterest: newInterestArray,
		pageCount: 0,
		showAllActive: false,
	}, ()=> { 
		this.getPastClasses(true);
	});
}

loadMorePastSessions = ()=>{
	let finalAllClasses = [];
	if ( this.state.pastOnDemandClassesTotalLength > this.state.pastOnDemandClasses.length || this.state.liveClassesTotalLength > this.state.pastClasses.length )
		{
			let tempPageCount = this.state.pageCount + 1;
			this.setState({
				pageCount: tempPageCount
			}, ()=>{this.getPastClasses();});
		}
	else
		{
				
			finalAllClasses = finalAllClasses.concat(this.state.arrayTemp);
			
			finalAllClasses.sort(function(a, b){
				if(a.scheduleDate > b.scheduleDate) { return -1; }
				if(a.scheduleDate < b.scheduleDate) { return 1; }
				return 0;
			});
			
			let arrayTemp = finalAllClasses;
			let arrayTempLength = finalAllClasses.length;
			
			let sliceTemp = finalAllClasses;
			let sliceTempLength = sliceTemp.length;
			
			this.setState({
				allClasses: sliceTemp,
				liveClassesLength: sliceTempLength,
				arrayTemp: arrayTemp,
				arrayTempLength: arrayTempLength
			}, () => {this.setClassesByInterest(this.state.chosenInterest)});
		}
}

setInstructorFilter = (fil)=>{
	var chosenHosts = this.state.chosenInstructorsFilter;
	
	if ( chosenHosts.indexOf(fil.id) == -1 )
		{
			chosenHosts.push(fil.id);
		}
	else
		{
			var indexOf = chosenHosts.indexOf(fil.id);
			chosenHosts.splice(indexOf, 1);
		}
	
	this.setState({
			chosenInstructorsFilter: chosenHosts
		}, ()=> { 
		this.getPastClasses(true);
	});
}

openCancelTrigger=()=>{
	if ( this.props.parentComponent == 'bookmarkClasses' ) 
		{
			this.props.updateStateFromChild({isOpenCancel: true});
		}
}

closeCancelTrigger=()=>{
	if ( this.props.parentComponent == 'bookmarkClasses' ) 
		{
			this.props.updateStateFromChild({isOpenCancel: false});
		}
}

searchFromMySchedule=(mod)=>{
	let interestArray = [];
	interestArray.push(mod);
	
	this.setState({
		chosenInterest: interestArray,
		showAllActive: false
	}, ()=>{  
			this.getLiveClasses(true);
			this.props.updateStateFromChild({chosenClassesMenu: 'Live'});
		});
}

setShowAll=()=>{
	if ( this.state.showAllActive )
		{
			this.setState({
				showAllActive: false,
			}, ()=>{
				this.getLiveClasses(true, false);
			});
		}
	else 
		{
			this.setState({
				showAllActive: true,
			},()=>{ 
				this.getLiveClasses(true, false)
			});
		}		
	
}

openNativeUrl = (nurl) => {
	
	if(!this.state.appDownload && localStorage.getItem('appDownload'))
		{
			this.setState({appDownload: localStorage.getItem('appDownload')});
		}
	
	if(!this.state.appDownload && localStorage.getItem('userData') && !localStorage.getItem('appDownload'))
		{
			var globalSettings = JSON.parse(localStorage.getItem('userData')).default;
		
			this.setState({appDownload: ( osname == "Windows" ? globalSettings.windowsAppLink : globalSettings.macAppLink )});
		}
		
	customProtocolCheck(nurl,
						  () => {
							  setTimeout( ()=>{
								window.close();
							}, 2000);
						  },
						  () => {
							 this.setState({loggedNative: false});
						  }, 15000);
}

openAsInstructor = (session)=>{
	localStorage.setItem('currentUser', this.state.currentUserData.id);
	localStorage.setItem('currentUserToken', this.state.currentUserData.token);
	this.getUserToken(session.hostId, session.sessionId);
}

getUserToken=(userId, sessionId)=>{
  let mainthis = this;
  axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/getUserToken", {id: userId})
  .then(res => {
	if(res.data.responseMessage === "success")
	  {
			let userToken = res.data.responseData;
			 const userData = {
				userId: userId,
				auth: userToken
			};
			 mainthis.setState({loginAsAnotherUser: true});
			 mainthis.props.updateStateFromChild({showLoader: true});
			  window['loginAsOtherUser'](userId, userToken).then((response) => {
					localStorage.setItem("userData", JSON.stringify(response));
					mainthis.openLiveClass(sessionId);
					mainthis.setState({loginAsAnotherUser: false});
					mainthis.props.updateStateFromChild({showLoader: false});
			  }).catch(error => {
			  });
		  }
	  else
	  {
	  }
  }).catch(err =>{
  });
 }
 
 loginAsOtherUser=(userId, userToken)=>{
		const userData = {
				userId: userId,
				auth: userToken
			};
        return new Promise((resolve, reject) => {
				axiosVirdio.post(process.env.REACT_APP_API_URL+"/api/v1/user/loginNative", userData).then(res => {
					resolve(res.data.responseData);
				  }).catch(err => {
					reject();
				});
        });
    }

reloadDetails=()=>{
	this.props.updateStateFromChild({isOpenDetailedClass: false});
}

  render() {
	 return (
		<div className={classnames({'classes_holder_main': true, 'classes_container_boomark': this.props.parentComponent == 'bookmarkClasses', 'empty_state_component': (this.state.classesDates.length == 0 && this.props.parentComponent == 'bookmarkClasses')})}>
			<div className="class_container">
				<div className={( (this.props.isOpenDetailedClass || ( this.state.classesDates.length == 0 && this.props.parentComponent != 'pastClasses')) ? "d-none" : "" )}>
					{ (this.props.parentComponent == 'mainPage' || this.props.parentComponent == 'pastClasses') &&
						<div className={"filter_interest_container " + (this.props.isMarketplace0 ? "margtp60" : "")}>
							<div className={( this.props.parentComponent == 'pastClasses' ? "pastFilter" : "" )}>
								{ this.props.parentComponent == 'pastClasses' &&
									<div className="pastFilterTitle">Filters</div>
								}
								<div className={( this.props.parentComponent == 'pastClasses' ? "pastCategoriesOut" : "" )}>
									{ this.props.parentComponent == 'pastClasses' &&
										<div className="pastCategories">Categories</div>
									}
									
									{this.props.parentComponent && this.props.parentComponent != 'pastClasses' &&
										<div className={"filter_interest " + ( this.state.showAllActive ? "active" : "" )} onClick={() => this.setShowAll()}>
											<div className="interest_title">Show All</div>
										</div>
									}
									{ this.state.classInterests.map((item, i) =>
										<div key={i} className={"filter_interest " + ( this.state.chosenInterest.indexOf(item.id) > -1 && !this.state.showAllActive ? "active" : "" )} onClick={() => this.props.parentComponent == 'pastClasses' ? this.changePastInterest(item.id) : this.changeInterest(item.id)}>
											<div className="interest_icon" style={{ backgroundImage: "url("+item.image_icon+")"}}></div>
											<div className="interest_title">{item.name}</div>
										</div>
									)}
								</div>
								{ this.props.parentComponent == 'pastClasses' &&
									<div className="pastCategoriesOut mrgtp16">
										<div className="pastCategories pastInstructIcon">Instructor</div>
										<div>
											<div className="filter_content">
												{ this.state.instructorsFilter.map((item, i) =>
												<div className={"one_filter one_filter_instructors " + ( this.state.chosenInstructorsFilter.indexOf(item.id) > -1 ? "active" : "" )}  key={i} onClick={() => this.setInstructorFilter(item)}>{item.firstName} {item.lastName}</div>
												)}
											</div>
										</div>
									</div>
								}
							</div>
						</div>
					}
					<div className={classnames({'classes_container': true, 'classes_container_all': this.props.parentComponent == 'bookmarkClasses', 'chWidthPast' : this.props.isMarketplace0})}>
						{ this.state.classesDates.map((date, index) =>
							<div className="classes_holder" key={index}>
								<div className="class_dates">{date}</div>
								{ this.state.classesByInterest[date].map((item, i) =>
									<div className={"myScheduleContent " + (((item.timeUntil && item.timeUntil < this.state.defaultJoinTime*60) && (item.hostId == this.state.currentUserData.id || item.bookingStatus == 0 || item.bookingStatus == 1)) ? "canJoin" : "")} key={i}>
										<div className="class_content">
											{ this.props.parentComponent == 'pastClasses' &&
												<div className="classSignInfoOut">
													<div className="classSignInfo">
														<div className={"classSingImg " + ( item.classType == "onDemand" ? "odSign" : "")}></div>
														<div className={"classSignName " + (item.classType == "onDemand" ? "min95" : "")}>{ item.classType == "onDemand" ? "On-demand" : "Live"}</div>
													</div>
												</div>
											}
											<div className={"left_class_content " + ((item.timeUntil < this.state.defaultJoinTime*60 && item.channelId == this.state.currentUserData.channelId && this.state.currentUserData.openAsInstructorPermission) ? "min222" : "" )} onClick={() => this.openClassDetails(item.sessionId)}>
												<div className="top_class_content">
													<div className={"class_icon " + ( item.isBookmarked == 1 ? "bookmarked_icon" : "" )} onClick={(e) => this.bookMarkClass(e, item)}></div>
													<div className="class_time">{moment(item.scheduleDate).format('hh:mm A')}</div>
													<div className="class_dot">&bull;</div>
													<div className="class_time">{item.sessionDuration} min</div>
													<div className="class_interest">{item.interestTitles}</div>
													{item.replayClassId > 0 &&
														<div className="class_interest">Replay</div> 
													}
												</div>
												<div className="class_name">{item.sessionName}</div>
												<div className="bottom_class_content">
													<div className="instructor_avatar" style={{ backgroundImage: item.hostImage && item.hostImage.indexOf('.s3') > -1 ? "url("+item.hostImage+")" : "url(./images/user_avatar.svg)"}}></div>
													<div className="instructor_name">{item.hostFirstName} {item.hostLastName}</div>
												</div>
											</div>
											<div className={"buttons_class_content " + (this.props.parentComponent == 'pastClasses' ? "d-none" : "" ) + ((item.timeUntil < this.state.defaultJoinTime*60 && item.channelId == this.state.currentUserData.channelId && this.state.currentUserData.openAsInstructorPermission) ? "w222" : "" )}>
												{ item.hostId != this.state.currentUserData.id ?
													<div>
														{ (item.bookingStatus == 0 || item.bookingStatus == 1) ?
															<div className={" " + (item.timeUntil > 0 ? 'outCancel': '')}>
																<div className="bookedSign">Booked</div>
																{ item.timeUntil > 0 &&
																	<div className="class_inactive_btn" onClick={() => this.openCancel(item.sessionId)}>Cancel</div>
																}
																{ item.timeUntil < this.state.defaultJoinTime*60 && item.channelId == this.state.currentUserData.channelId && this.state.currentUserData.openAsInstructorPermission && item.replayClassId == 0 &&
																	<div className="outOpenInstructor">
																		<div className="class_active_btn wAuto" onClick={() => this.openAsInstructor(item)}>Open as Instructor</div>
																	</div>
																}
															</div>
															:
															<div>
																{ (item.bookingStatus == null || item.bookingStatus == 4 ) &&
																	<div>
																		{ this.props.openWithoutToken && this.props.openWithoutToken == 'marketplaceglobal' ?
																			<div>
																				{ localStorage.getItem('userData') ?
																					<a href={process.env.REACT_APP_URL+"/marketplaceglobal#"+item.sessionId} target="_top">
																						<div className="class_active_btn chButtonStyle">Launch App</div>
																					</a>
																					:
																					<a href={process.env.REACT_APP_ADMINURL+"/MemberRegister"+this.state.srchutm} target="_top">
																						<div className="class_active_btn chButtonStyle">Sign Up</div>
																					</a>
																				}
																			</div>
																			:
																			<div>
																				<div className="class_active_btn" onClick={() => this.bookSession(item.sessionId)}>Book</div>
																				{ item.timeUntil < this.state.defaultJoinTime*60 && item.channelId == this.state.currentUserData.channelId && this.state.currentUserData.openAsInstructorPermission && item.replayClassId == 0 &&
																					<div className="outOpenInstructor">
																						<div className="class_active_btn wAuto" onClick={() => this.openAsInstructor(item)}>Open as Instructor</div>
																					</div>
																				}
																			</div>
																		}
																	</div>
																}
															</div>
														}
													</div>
													:
													<div>
														{ item.replayClassId == 0 ?
															<>
																{ (item.bookingStatus == 0 || item.bookingStatus == 1) &&
																	<div className="bookedSign">Hosting</div>
																}
															</>
															:
															<>
																{ (item.bookingStatus == 0 || item.bookingStatus == 1) ?
																		<div className={" " + (item.timeUntil > 0 ? 'outCancel': '')}>
																			<div className="bookedSign">Booked</div>
																			{ item.timeUntil > 0 &&
																				<div className="class_inactive_btn" onClick={() => this.openCancel(item.sessionId)}>Cancel</div>
																			}
																		</div>
																		:
																		<div>
																			{ (item.bookingStatus == null || item.bookingStatus == 4 ) &&
																				<div>
																					<div className="class_active_btn" onClick={() => this.bookSession(item.sessionId)}>Book</div>
																				</div>
																			}
																		</div>
																	}
															</>
														}
													</div>
												}
											</div>	
										</div>
										{ (item.timeUntil < this.state.defaultJoinTime*60) && ((item.hostingSession && item.hostingSession == 1) || (item.bookingStatus == 0 || item.bookingStatus == 1))  &&
											<div className={"joinSesButton " + (this.props.parentComponent == 'pastClasses' ? "d-none" : "" )} onClick={() => this.openClass(item.sessionId)}>
												{ item.timeUntil && item.timeUntil < 0 ?
													<div className="startingSign">Class in progress</div>
													:
													<div className="startingSign">Class starts in <span>{(item.timeUntil/60)>=10 ? Math.floor(item.timeUntil/60) : '0'+Math.floor(item.timeUntil/60)}</span> : <span>{(item.timeUntil-Math.floor(item.timeUntil/60)*60)>=10 ? (item.timeUntil-Math.floor(item.timeUntil/60)*60) : '0'+(item.timeUntil-Math.floor(item.timeUntil/60)*60)}</span></div>
												}
												<div className="joinSesSign">JOIN CLASS</div>
											</div>
										}
									</div>
								)}
							</div>
						)}
						{ ((this.state.liveClassesTotalLength > this.state.liveClassesLength && this.props.parentComponent != 'pastClasses') || (this.props.parentComponent == 'pastClasses' && this.state.arrayTempLength > this.state.liveClassesLength)) &&
							<div className="loadMore" onClick={() => this.props.parentComponent == 'pastClasses' ? this.loadMorePastSessions() : this.loadMoreLiveSessions()}>Load More</div>
						}
						{ (this.state.classesDates.length == 0 && this.state.isLoadedClasses && this.props.parentComponent == 'pastClasses') &&
							<div className="empty_state">No available classes.</div>
						}
					</div>
				</div>
				{ this.state.classesDates.length == 0 && this.state.isLoadedClasses && this.props.parentComponent != 'pastClasses' && !this.props.isOpenDetailedClass &&
					<div className="empty_state">{this.props.parentComponent == 'bookmarkClasses' ? 'No available Bookmarked Live classes.' : 'No available Live classes.'}</div>
				}
			</div>
			{ this.state.classBoking &&
				<CancelBooking updateStateFromChild={this.updateStateFromChild} cancelSessionStatus={this.cancelSessionStatus} sessionId={this.state.sessionToCancel}></CancelBooking>
			}
			<div className={( !this.props.isOpenDetailedClass ? "d-none" : "" )}>
				<LiveClassDetails 
					failedPaymentStatus={(this.props && this.props.state ? this.props.state.failedPaymentStatus : false)}
					closeDetails={this.closeDetails} 
					updateParent={this.updateParent} 
					classInfo={this.state.classInfo} 
					getLiveClasses={this.getLiveClasses} 
					openClass={this.openClass} 
					openCancelTrigger={this.openCancelTrigger}
					closeCancelTrigger={this.closeCancelTrigger}
					fromMarketplaceLive={true}
					reloadDetails={this.reloadDetails}
					ref={this.refDetails}></LiveClassDetails>
			</div>
			{ this.state.showPopupLaunchApp &&
				<div>
					<div className="full_popup">
						<ParticipantSignedUp 
							state={this.state}
							openWithoutToken={this.props.openWithoutToken}
							updateStateFromChild={this.updateStateFromChild}
							openNativeUrl={this.openNativeUrl}
							sessionStartTimeHigher15Min={this.state.sessionStartTimeHigher15Min}
							urlElectron={this.state.urlElectron}
							urlPath={this.state.urlPath}
							scheduleDate={this.state.sessionScheduleDate}
							timeZone={this.state.sessionTimezone}
							sessionChannelName={this.state.sessionChannelName}
							isHost={this.state.isHost}
							sessionName={this.state.sessionName}
							isOnDemandSession={this.state.isOnDemandSession}
							onDemandId={this.state.demandSessionId}
							channelName={this.state.channelName}
							loggedNative={this.state.loggedNative}
							>
						</ParticipantSignedUp>
					</div>
				</div>
			}
			{ this.state.loginAsAnotherUser &&
				<div>
					<LoginAnotherUserPopup>
					</LoginAnotherUserPopup>
				</div>
			}
		</div>
    );
  }
}
export default connect(
  null,
  { 
	showMainErrorPop
  },
  null,
  {forwardRef: true}
)(MarketplaceLive);